import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { NbToastrService, NbDialogService } from '@nebular/theme';
import { LocalDataSource } from 'ng2-smart-table';
import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';

import {
  MealPlanData,
  MealPlan,
} from 'app/@core/interfaces/common/CalorieFriend/plan';
import { ConfirmMessageDialogComponent } from 'app/@components/confirm-message-dialog/confirm-message-dialog.component';

import { MealPlanDefComponent } from '../PlanDef/plan-def.component';
import { TemplateGenerateComponent } from './template-generate.component';

@Component({
  selector: 'app-plan-list',
  templateUrl: './plan-list.component.html',
  styleUrls: ['./plan-list.component.scss'],
})
export class PlanListComponent implements OnInit {
  PlanListLabel = 'Plans';
  AddPlanLabel = 'New Plan';
  PlanNameLabel = 'Name';
  PlanActiveDaysLabel = 'Days';
  PlanActiveStateLabel = 'Active';
  AcceptLabel = 'SAVE PLANS';
  BackLabel = 'Back';
  TemplateLabel = 'Template';
  SucessDeletePlan = 'Sucessfully deleted Plan';
  FailDeletePlan = 'Problem occurred deelting Plan';

  PatientID = null;

  Plans: Array<MealPlan> = null;
  PlanSource: LocalDataSource = null;
  PlanListSource: DataSource = null;

  PlansTableSettings = {
    hideSubHeader: true,
    mode: 'external',
    actions: {
      columnTitle: $localize`:@@Actions:Actions`,
      position: 'right',
      add: false,
    },
    edit: {
      editButtonContent:
        '<img src="assets/icons/added_oultine_modify_pencil.svg" title="' +
        $localize`:@@Edit:Edit` +
        '" class="img-archive" width="24" height="24">',
    },
    delete: {
      deleteButtonContent:
        '<img src="assets/icons/trash-2-outline.svg" title="' +
        $localize`:@@Delete:Delete` +
        '" class="img-archive" width="24" height="24">',
    },
    columns: {
      name: { title: $localize`:@@Name:Name`, type: 'string', filter: false },
      // days: { title: this.PlanActiveDaysLabel, type: 'number', filter: false },
      active: {
        title: $localize`:@@Active:Active`,
        type: 'boolean',
        filter: false,
      },
      template: {
        title: $localize`:@@Template:Template`,
        type: 'custom',
        renderComponent: TemplateGenerateComponent,
        valuePrepareFunction: (value, row, cell) => {
          return { ThePlan: row };
        },
        filter: false,
      },
    },
  };

  protected readonly unsubscribe$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private plansService: MealPlanData,
    private toasterService: NbToastrService
  ) {
    this.PlanListSource = this.plansService.gridDataSource;
  }

  ngOnInit(): void {
    this.PatientID = +this.route.snapshot.paramMap.get('PatientId');
    this.PlanListSource.addFilter({
      field: 'patientId',
      search: this.PatientID,
    });

    this.Plans = new Array<MealPlan>();
    this.PlanSource = new LocalDataSource(this.Plans); // create the source
  }

  AddPlan() {
    this.dialogService
      .open(MealPlanDefComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: { PatientID: this.PatientID },
      })
      .onClose.subscribe((plan) => this.UpdatePlan(plan));
  }

  UpdatePlan(Plan: MealPlan) {
    if (Plan !== null && Plan !== undefined) {
      this.Plans = this.Plans.filter(
        (plan) => plan.id !== Plan.id || plan.name !== Plan.name
      );
      this.Plans.push(Plan);
      this.PlanSource = new LocalDataSource(this.Plans); // create the source
    }

    this.PlanListSource.refresh();
  }

  onEdit($event) {
    this.dialogService
      .open(MealPlanDefComponent, {
        closeOnEsc: false,
        closeOnBackdropClick: false,
        context: {
          ThePlan: $event.data,
        },
      })
      .onClose.subscribe((plan) => this.UpdatePlan(plan));
  }

  onDelete($event) {
    this.dialogService
      .open(ConfirmMessageDialogComponent, {
        closeOnEsc: true,
        closeOnBackdropClick: true,
        context: { Message: 'Are you sure to delete this plan?' },
      })
      .onClose.subscribe((result) => {
        if (result) {
          const observable = this.plansService.delete($event.data.id);

          observable.pipe(takeUntil(this.unsubscribe$)).subscribe(
            () => {
              this.handleGoalDeleteSuccessResponse();
            },
            (err) => {
              this.handleGoalDeleteWrongResponse();
            }
          );
        }
      });
  }

  handleGoalDeleteSuccessResponse() {
    this.toasterService.success('', this.SucessDeletePlan);
    this.PlanListSource.refresh();
  }

  handleGoalDeleteWrongResponse() {
    this.toasterService.danger('', this.FailDeletePlan);
  }

  Back() {
    this.router.navigate([`/pages/CalorieFriend/Patient/${this.PatientID}`]);
  }
}
